import { useTranslation } from 'react-i18next';
import { StatusContainer, StatusText, TrendingIcon } from './styled';

const StatusLabel = () => {
  const { t } = useTranslation();
  return (
    <StatusContainer>
      <TrendingIcon />
      <StatusText>{t('distribution:playbackStats:status:up')}</StatusText>
    </StatusContainer>
  );
};

export default StatusLabel;
